module.exports = __webpack_public_path__ + "static/media/cmk.b3c50bb8.svg";